import BaseObject from './BaseObject.js';
import TertiaryMenuItem from './TertiaryMenuItem.js';

export default class SecondaryMenuItem extends BaseObject {
  constructor(id, component, props) {
    super();
    this.id = id;
    this.children = [];
    this.features = [];

    this.primary = null;

    this.component = component;
    this.props = props;
    this.open = false;
  }

  get hasChildren() {
    return (this.children || []).length > 0;
  }

  get path() {
    return `/${this.primary}/${this.id}`;
  }

  get route() {
    if ((this.component || null) === null) {
      return null;
    }
    return {
      path: this.path,
      name: this.id,
      component: this.component,
      props: this.props,
      meta: {
        verifyAuth: true,
        primary: this.primary,
        secondary: this.id,
        title: this.id
      },
    };
  }

  Registered(primary) {
    this.primary = primary.id;
  }

  RegisterChild(tertiary) {
    if (tertiary instanceof TertiaryMenuItem) {
      this.children.push(tertiary);
      tertiary.Registered(this);
    }
  }

  ClearChildren() {
    this.children = [];
    this.features = [];
  }
}
